<!-- <form [formGroup]="form1">
    <div *ngIf="config.type === 'matrix'">
        <label>{{ config.name }}</label>
        <div formArrayName="{{ config.name }}">
            <div *ngFor="let matrixControl of matricesFA.controls; let mi = index" [formGroupName]="mi">
                <button mat-icon-button type="button" (click)="removeMatrix(mi)">
                    <mat-icon>delete</mat-icon>
                </button>
                <div formArrayName="rows" class="bracket-box">
                    <div *ngFor="let rowGroup of getRowsControls(mi); let ri = index" [formGroupName]="ri"
                        class="bracket-box">
                        <div formArrayName="cells" style="display: flex; align-items: center;">
                            <div *ngFor="let cellControl of getCellsControls(mi, ri); let ci = index">
                                <mat-form-field style="width: 60px;">
                                    <input matInput type="number" [formControl]="cellControl" value="Sushi">
                                </mat-form-field>
                                <button type="button" (click)="removeCell(mi, ri, ci)" title="Eliminar celda">
                                    ×
                                </button>
                            </div>
                            <button mat-icon-button type="button" (click)="addCell(mi, ri)"
                                style="margin-left: 0.5rem;">
                                <mat-icon>add</mat-icon>
                            </button>
                            <button mat-icon-button type="button" (click)="removeRow(mi, ri)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                    <button mat-icon-button type="button" (click)="addRow(mi)">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <button mat-icon-button type="button" (click)="addMatrix()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</form>
<p>Resultado final: {{ getResult() | json }}</p> -->







<mat-dialog-content class="mat-typography">

    @if(rules$ | async; as rules){
    @if(!disableInput){
    <app-search-autocomplete [disabledBool]="disableInput" [title]="'Busca una regla para continuar'" [items]="rules"
        (itemSelected)="onItemSelected($event)">
    </app-search-autocomplete>
    <br>
    }

    <form [formGroup]="taskRuleForm" (ngSubmit)="saveRuleTaskParms()">





        @if($FORM_CONFIG | async; as form_config){
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>Label de regla</mat-label>
            <input matInput formControlName="taskrulelabel">
        </mat-form-field>
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>Peso de regla</mat-label>
            <input matInput formControlName="taskruleweights">
        </mat-form-field>
        @if(form_config){

        <h4>Parámetros</h4>

        <app-dynamic-forms [DYNAMIC_FORM_CONFIG]="form_config" (onValueChange)="onValueChange($event)"
            [DATA]="this.task_rule_parameters_data"></app-dynamic-forms>
        }

        }
    </form>
    }


</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Cancelar</button>
    <button color="primary" mat-raised-button (click)="saveRuleTaskParms()" cdkFocusInitial
        [disabled]="!taskRuleForm.valid">Guardar</button>
</mat-dialog-actions>